let accessToken: string | null = null;
let accessTokenExpiresAt: string | null = null;

export const setAccessToken = (token: string | null, expiresAt?: string | null) => {
  accessToken = token;
  accessTokenExpiresAt = expiresAt || null;
};

export const getAccessToken = () => {
  return accessToken;
};

export const getAccessTokenExpiresAt = () => {
  return accessTokenExpiresAt;
};

export const isAccessTokenExpired = (bufferMs = 30000) => {
  if (!accessTokenExpiresAt) return !accessToken;

  return new Date(accessTokenExpiresAt).getTime() - bufferMs <= Date.now();
};

export const clearAccessToken = () => {
  accessToken = null;
  accessTokenExpiresAt = null;
};
